<template>
    <div>
        <ecomodal></ecomodal>
        <htmodal></htmodal>
        <noemodal></noemodal>
    </div>
</template>

<script>
import ecomodal from './Modalz/ecomodal'
import htmodal from './Modalz/htmodal'
import noemodal from './Modalz/noemodal'

export default {
  name: 'RefModalz',
  components: {ecomodal, htmodal, noemodal}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/RefModalz.vue